// Cliente Supabase — F4-lite (auth magic link + sync de estado)
// A anon key é pública por design; os dados são protegidos por RLS no servidor.

import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://twegixcetwwscluctttt.supabase.co';
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3ZWdpeGNldHd3c2NsdWN0dHR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMwMzI5MjEsImV4cCI6MjA5ODYwODkyMX0.FLt98iMCCsV-6fgcMvfkfrci6tyFABtoiCsYWyXS__A';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
